import { createProvider } from '@nvision/services/data-provider';

import type { PricingTypeFilters } from '../../models';
import * as api from './api';
import { normalizePricingTypeFilters, normalizePricingTypes } from './normalize';

export const fetchPricingTypes = createProvider(
  (filters: Partial<PricingTypeFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchPricingTypes(normalizePricingTypeFilters(filters), { signal }),
).andThen((res) => normalizePricingTypes(res));
